import Env from '../../base/env';
import Component from 'gia/Component';
import CursorFollow from '../../fx/CursorFollow';
import gsap from 'gsap';
import easesCustom from '../../fx/CustomEases';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../../vendor/gsap-bonus-umd/SplitText';
gsap.registerPlugin(ScrollTrigger,SplitText);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.cache = this.DOM.view.querySelector('.fxCacheSEO')
    this.DOM.separator = this.DOM.view.querySelector('.fxSeparator')
    this.DOM.items = this.DOM.view.querySelectorAll('.js-item-all')
    //! FX
    this.FX = {}
    this.FX.items = []
    for(let item of this.DOM.items) {
      const fx = new SplitText(item.querySelector('.fx-text'), { type:'chars' })
      gsap.set(fx.chars, { y: 150 })
      this.FX.items.push(fx)
    }
    this.FX.chars = []
    for(let fx of this.FX.items) {
      const separator = fx.elements[0].parentElement.querySelector('.fx-separator')

      for(let char of fx.chars) {
        this.FX.chars.push(char)
      }
      this.FX.chars.push(separator)
    }
    //! Fns
    setTimeout(() => {
      this.cursor = new CursorFollow(this.DOM.view.querySelector('.fxRail'))
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.cache,
        {
          autoAlpha:1
        },
        {
          autoAlpha:0,
          ease:'cubic.out',
          duration:1.5
        }
      ),
    ])
    // .add([

    // ])
    .add([
      gsap.fromTo(
        this.DOM.separator,
        {
          scaleX:0,
          transformOrigin:'left top',
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.8,
          delay:1.1
        }
      ),
      gsap.fromTo(
        this.FX.chars,
        {
          y:150
        },
        {
          y:0,
          ease:easesCustom.quart,
          duration:.6,
          stagger:.01
        }
      ),
    ],'-=2')
    .add(()=>{
      for(let fx of this.FX.items) {
        fx.revert()
      }
    })
  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 60%'
    })
  }

  unmount()
  {
    this.st.kill(true)
  }
}
